"use strict";

const { MAX_SAFE_INTEGER } = require("./max_safe_integer.js");
const { MAX_SAFE_INTEGER_LENGTH } = require("./max_safe_integer_length.js");
const { PI } = require("./pi_100.js");

module.exports = {
  MAX_SAFE_INTEGER,
  MAX_SAFE_INTEGER_LENGTH,
  PI
};
